import logger from 'consola'

// Only report errors and warnings to production.
// In development, only log error, wanring, and logs, unless overriden by LOG_LEVEL
logger.level = process.env.STAGE === 'prod' ? 2 : process.env.LOG_LEVEL || 3

// Redirect all uses of console to the Consola instance
logger.wrapConsole()

export default logger
